export interface HomeModuleStatus {
  id: string;
  connection?: { status: string; resourceCount?: number };
}

/** Identity is not evidence. Render widgets only for configured modules or real work. */
export function getWorkspaceHomeWidgetVisibility(input: {
  project: { onboarding_completed?: boolean; onboarding_job_id?: string | null } | null;
  modules?: HomeModuleStatus[];
  trafficSourceCount?: number;
  trafficRowCount?: number;
  issueCount?: number;
  activityCount?: number;
  workLoading?: boolean;
  workError?: boolean;
}) {
  const trafficProviders = new Set(['ga4', 'gsc', 'bing_webmaster', 'cloudflare']);
  const hasBoundTrafficModule = (input.modules || []).some(
    module =>
      trafficProviders.has(module.id) &&
      (['connected', 'syncing', 'read_only'].includes(module.connection?.status || '') ||
        (module.connection?.status === 'needs_attention' &&
          Boolean(module.connection.resourceCount)))
  );
  return {
    intelligence: Boolean(
      input.project?.onboarding_completed ||
        input.project?.onboarding_job_id ||
        input.modules?.some(
          module =>
            module.id === 'intelligence' &&
            ['collecting', 'ready', 'failed'].includes(module.connection?.status || '')
        )
    ),
    traffic: Boolean(hasBoundTrafficModule || input.trafficSourceCount || input.trafficRowCount),
    work: Boolean(input.issueCount || input.activityCount || input.workLoading || input.workError),
  };
}
